module.exports = __webpack_public_path__ + "img/iceland.a461ac48.png";